import actions from '../../actionTypes';

export default workflow => {
  return {
    type: actions.EDITED_WORKFLOW,
    workflow
  };
};



// WEBPACK FOOTER //
// ./src/reducers/workflows/actions/editedWorkflow.js